import { useHistory } from 'react-router-dom';
import { HeaderMenuAction } from '../../components/HeaderBar/types';
import { KeyboardShortcut } from './useKeyboardShortcut.types';
import { useKeyboardShortcuts } from './useKeyboardShortcuts';

export const useHeaderActionShortcuts = (
  menuActions: HeaderMenuAction[],
): void => {
  const history = useHistory();
  const shortcuts: KeyboardShortcut[] = menuActions.map((action) => ({
    category: 'common',
    description: action.label,
    keys: action.keyboardShortcut,
    handler: () => history.push(action.to),
  }));

  useKeyboardShortcuts(shortcuts, [menuActions]);
};
